import { useFormik } from "formik";
import * as Yup from "yup";
import { validateCPF } from "../../../utils/DocumentUtils";
import ModalInfo from "../../../components/lib/modalInfo";
import { RiErrorWarningLine } from "react-icons/ri";

const ParentEditForm = ({ initialData, onSubmit, onDirty }) => {
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: initialData?.name || "",
            cpf: initialData?.cpf || "",
            email: initialData?.email || "",
            phone_number: initialData?.phone_number || "",
            address: initialData?.address || "",
            client_code: initialData?.client_code,
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .required("Nome obrigatório")
                .max(50)
                .test(
                    "two-words",
                    "O nome deve ser completo",
                    (v) => v && v.trim().split(/\s+/).length >= 2
                ),
            cpf: Yup.string()
                .required("CPF obrigatório")
                .length(11)
                .matches(/^\d+$/)
                .test("valid-cpf", "CPF inválido", validateCPF),
            email: Yup.string()
                .email("Email inválido")
                .required("Email obrigatório"),
        }),
        onSubmit,
    });

    const handleCpfBlur = (e) => {
        const digits = e.target.value.replace(/\D/g, '');
        if (digits.length > 0 && digits.length < 11) {
            formik.setFieldValue('cpf', digits.padStart(11, '0'));
        }
        formik.handleBlur(e);
    };

    return (
        <form
            data-step-form
            onSubmit={formik.handleSubmit}
            onChange={onDirty}
            className="flex flex-col gap-4"
        >
            <h3 className="text-lg font-semibold">
                Dados do Responsável
            </h3>

            <label>
                <div className="flex items-center justify-between">
                    <p>Nome</p>
                    <ModalInfo icon={<RiErrorWarningLine />} content="Campo Obrigatório!" />
                </div>
                <input
                    className={`block w-full px-3 py-1.5 border rounded ${formik.touched.name && formik.errors.name ? "border-red-500" : "border-gray-300"}`}
                    name="name"
                    type="text"
                    onChange={(e) => { onDirty(); formik.handleChange(e); }}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name && (
                    <p className="text-red-500 text-xs">{formik.errors.name}</p>
                )}
            </label>


            <label>
                <div className="flex relative items-center justify-between">
                    <p> CPF </p>
                    <ModalInfo
                        icon={<RiErrorWarningLine />}
                        content="Campo Obrigatório!"
                    />
                </div>
                <input
                    className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.cpf && formik.errors.cpf ? 'border-red-500' : ''
                        }`}
                    name="cpf"
                    type="text"
                    onChange={(e) => { onDirty(); formik.handleChange(e); }}

                    onBlur={handleCpfBlur}
                    value={formik.values.cpf}
                />
                {formik.touched.cpf && formik.errors.cpf && (
                    <p className="text-red-500 text-xs font-medium absolute">{formik.errors.cpf}</p>
                )}
            </label>

            <div className="grid grid-cols-2 gap-4">
                <label>
                    <div className="flex items-center justify-between">
                        <p>Email</p>
                        <ModalInfo
                            icon={<RiErrorWarningLine />}
                            content="Campo Obrigatório!"
                        />
                    </div>
                    <input
                        className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.barcode && formik.errors.barcode ? 'border-red-500' : ''
                            }`}
                        name="email"
                        type="text"
                        onChange={formik.handleChange}

                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email && (
                        <p className="text-red-500 text-xs font-medium absolute">{formik.errors.email}</p>
                    )}
                </label>

                <label>
                    <div className="flex items-center justify-between">
                        <p>Telefone</p>
                    </div>
                    <input
                        className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.phone_number && formik.errors.phone_number ? 'border-red-500' : ''
                            }`}
                        name="phone_number"
                        type="text"
                        onChange={formik.handleChange}

                        onBlur={formik.handleBlur}
                        value={formik.values.phone_number}
                    />
                    {formik.touched.phone_number && formik.errors.phone_number && (
                        <p className="text-red-500 text-xs font-medium absolute">{formik.errors.phone_number}</p>
                    )}
                </label>


            </div>

            <label>
                <div className="flex items-center justify-between">
                    <p>Endereço</p>
                </div>
                <input
                    className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.address && formik.errors.address ? 'border-red-500' : ''
                        }`}
                    name="address"
                    type="text"
                    onChange={formik.handleChange}

                    onBlur={formik.handleBlur}
                    value={formik.values.address}
                />
            </label>
        </form>
    );
};

export default ParentEditForm;
